import React, { useContext } from "react";

import { dragAndDropStyle, thumbStyle } from "../../../../../theme/theme";
import LinearProgress from "@material-ui/core/LinearProgress";
import CloseIcon from "@material-ui/icons/Close";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import { getImageFileType } from "../../../../../utils/utils";
import { LANGUAGE_TEXT } from "../../../../../constants";
import { EWContext } from "../../../../../context/EWContext";

function UploadFileTable(props) {
   const {
      fileAccepted,
      fileName,
      fileSize,
      previewLink,
      span,
      progressValue,
      progressError,
      errorUploadedIcon,
      uploadedFileIcon,
      deleteButtonIcon,
   } = dragAndDropStyle();

   const accountState = useContext(EWContext)[0];

   const { thumb, thumbInner, img } = thumbStyle();

   const { files, removeRejectedFile, removeAcceptedFile } = props;

   const fileLink = (linkErrors, file) => {
      if (linkErrors) {
         return <strong>{file.file.path}</strong>;
      } else {
         return (
            <a
               style={previewLink}
               target="_blank"
               rel="noopener noreferrer"
               href={file.path}
            >
               {file.name}
            </a>
         );
      }
   };

   const fileError = (fileErrors, file) => {
      if (fileErrors) {
         return <ErrorOutlineOutlinedIcon style={errorUploadedIcon} />;
      } else if (getImageFileType(file.type)) {
         return (
            <img
               src={file.base64 ? file.base64 : file.path}
               className={img}
               alt={file.path}
            />
         );
      } else if (file.type?.includes(".pdf")) {
         return <PictureAsPdfIcon style={uploadedFileIcon} />;
      } else {
         return <CheckCircleOutlineOutlinedIcon style={uploadedFileIcon} />;
      }
   };

   const fileCloseIcon = (closeErrors, file) => {
      return (
         <CloseIcon
            color="action"
            style={deleteButtonIcon}
            onClick={(e) => {
               e.preventDefault();
               closeErrors
                  ? removeRejectedFile(file)
                  : removeAcceptedFile(file);
            }}
         />
      );
   };

   return files.map((file, index) => {
      return (
         <div key={index} style={{ width: "100%" }}>
            <table key={index} style={fileAccepted}>
               <tbody>
                  <tr>
                     <td
                        rowSpan="3"
                        style={{
                           width: "15%",
                           verticalAlign: "top",
                           display: "table-cell",
                           padding: 0,
                        }}
                     >
                        <div id="file-thumb" className={thumb}>
                           <div className={thumbInner}>
                              {fileError(file.errors, file)}
                           </div>
                        </div>
                     </td>
                     <td
                        style={{
                           width: "55%",
                           verticalAlign: "top",
                           display: "table-cell",
                           padding: "5px 0px 0px 0px",
                        }}
                     >
                        <span variant="body1" style={fileName}>
                           {fileLink(file.errors, file)}
                        </span>
                     </td>
                     <td
                        style={{
                           width: "20%",
                           verticalAlign: "top",
                           display: "table-cell",
                           padding: "5px 0px 0px 0px",
                           textAlign: "right",
                        }}
                     >
                        <span variant="body1" style={fileSize}>
                           {" "}
                           {file.size}
                        </span>
                     </td>
                     <td
                        style={{
                           width: "10%",
                           verticalAlign: "top",
                           display: "table-cell",
                           padding: "5px 10px 0px 0px",
                           textAlign: "right",
                        }}
                     >
                        {fileCloseIcon(file.errors, file)}
                     </td>
                  </tr>
                  <tr>
                     <td
                        colSpan="2"
                        style={{
                           verticalAlign: "top",
                           display: "table-cell",
                           padding: "0 0 10px 0",
                        }}
                     >
                        <LinearProgress
                           variant="determinate"
                           color={file.errors ? "primary" : "secondary"}
                           value={file.errors ? 100 : file.progress}
                        />
                     </td>
                  </tr>
                  <tr>
                     <td
                        colSpan="3"
                        style={{
                           verticalAlign: "top",
                           display: "table-cell",
                           padding: 0,
                        }}
                     >
                        {file.errors ? (
                           file.errors.map((e) => (
                              <span
                                 key={e.code}
                                 style={{ ...span, ...progressError }}
                              >
                                 Failed - {e.message}
                              </span>
                           ))
                        ) : (
                           <span style={{ ...span, ...progressValue }}>
                              {file.progress}%{" "}
                              {accountState?.conditionSpecificBehaviors
                                 ?.translateText &&
                              accountState?.storeInfo?.languageCode
                                 ? LANGUAGE_TEXT[
                                      accountState?.storeInfo?.languageCode
                                   ]?.complete_text
                                 : "complete"}
                           </span>
                        )}
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      );
   });
}

export default UploadFileTable;
